import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

const EpisodeList: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-neutral-900 font-heading">Episodes</h1>
      <Card>
        <CardHeader>
          <CardTitle>Episode Management</CardTitle>
        </CardHeader>
        <CardContent>
          <p>This section is under development. Episode listing and management features will be available here soon.</p>
          {/* Placeholder for future content, like a table or list of episodes */}
        </CardContent>
      </Card>
    </div>
  );
};

export default EpisodeList; 